import { Link } from "react-router-dom";


const how = [
  {
    head: "Prepare for Tests & Exams",

    content:
      "Upload textbooks, handouts, past questions, lecture notes, or Areas of Concentration (AOC). Koye generates practice questions from your materials and teaches you how to solve each one, step by step.",
  },
  {
    head: "Solve Any Assignment or Project",

    content:
      "Stuck on a difficult concept? Chat with Koye in normal conversation mode and get clear, plain-English explanations that actually make sense.",
  },
  {
    head: "Master Your Weaknesses",

    content:
      "No more wasting time trying to understand difficult concepts, Koye will simplify complex topics into plain English that makes sense. ",
  },
];

export default function How() {


return (
  <div>
    <main className=" container">
      <h1 className="text-center mb-[70px]">How it works:</h1>
      <div className="flex max-lg:flex-col gap-10">
        <div className="flex-1">
          <div className="flex gap-[60px] flex-col">
            {how.map((data =>
            <div key={data}>
              <h2 className="mb-4"><span className="bg-blue w-[4px] h-6 rounded-full inline-block mr-10 "></span> {data.head}</h2>
              <p>{data.content}</p>

            </div>

            ))}

          </div>
        <Link to="../premium"><button className="btn-purple btn my-[60px]">Get Premium</button></Link>  
        </div>
        <div className=" flex-1 lg:justify-items-end">
          <div className="rounded-[24px] bg-blue  ">
          <p className="lg:py-[300px] py-[100px] px-[100px] text-center ">Tutorial Video</p>
         </div> </div>
      </div>
    </main>
  </div>
);
}
